<div class="root" aria-hidden="true">
  <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M42.2928 87.2622L10.5359 19.0679L28.4902 11.6038L89.4271 62.8128L42.2928 87.2622Z"
      fill="url(#paint0_linear_1305_16041)" />
    <path d="M57.3679 68.7467L87 26L89.4588 26L89.4588 77.6445L57.3679 68.7467Z"
      fill="url(#paint1_linear_1305_16041)" />
    <rect x="2.30959" y="14.776" width="37.2961" height="37.2961" rx="9" transform="rotate(-22.8223 2.30959 14.776)"
      fill="var(--bg-secondary-400)" stroke="var(--secondary-icon-color)" stroke-width="2" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M20.0393 26.7067L15.8565 16.767L25.4049 18.5988L20.0393 26.7067Z"
      fill="var(--secondary-icon-color)" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M24.2229 36.6467L20.0401 26.7069L29.5885 28.5387L24.2229 36.6467Z"
      fill="var(--secondary-icon-color)" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M29.5872 28.5378L25.4043 18.598L34.9528 20.4299L29.5872 28.5378Z"
      fill="var(--secondary-icon-color)" />
    <path
      d="M95.2828 29.4743L94.6821 27.4769C94.3634 26.4174 93.637 25.5279 92.6625 25.0041C91.6881 24.4802 90.5454 24.3649 89.4859 24.6835L83.4938 26.4856C82.4343 26.8043 81.5448 27.5307 81.0209 28.5052C80.4971 29.4796 80.3818 30.6223 80.7004 31.6818L81.3011 33.6792"
      stroke="var(--bg-secondary-500)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    <path
      d="M85.2882 21.5899C87.4944 20.9264 88.745 18.6 88.0815 16.3937C87.418 14.1875 85.0916 12.9369 82.8854 13.6004C80.6791 14.2639 79.4285 16.5903 80.092 18.7965C80.7555 21.0028 83.0819 22.2534 85.2882 21.5899Z"
      stroke="var(--bg-secondary-500)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M68.0007 92.0002L22.5001 99.4999L18.0003 99.4996L52.5006 67L68.0007 92.0002Z"
      fill="url(#paint2_linear_1305_16041)" />
    <rect x="7.78809" y="86.0605" width="28.6783" height="28.6783" rx="6" transform="rotate(-6.5522 7.78809 86.0605)"
      fill="var(--secondary-icon-color)" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M18.5762 98.6849L17.6782 90.8661L23.993 94.1018L18.5762 98.6849Z"
      fill="var(--bg)" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M19.4756 106.504L18.5776 98.685L24.8924 101.921L19.4756 106.504Z"
      fill="var(--bg)" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M24.8916 101.92L23.9936 94.1015L30.3084 97.3371L24.8916 101.92Z"
      fill="var(--bg)" />
    <defs>
      <linearGradient id="paint0_linear_1305_16041" x1="10.3339" y1="3.88906" x2="70.4056" y2="83.557"
        gradientUnits="userSpaceOnUse">
        <stop offset="0.39" stop-color="var(--bg)" />
        <stop offset="0.905" stop-color="var(--bg)" stop-opacity="0" />
      </linearGradient>
      <linearGradient id="paint1_linear_1305_16041" x1="87.5" y1="22.5" x2="75.6241" y2="83.0273"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="var(--bg)" />
        <stop offset="0.905" stop-color="var(--bg)" stop-opacity="0" />
      </linearGradient>
      <linearGradient id="paint2_linear_1305_16041" x1="5.83634" y1="113.619" x2="65.326" y2="61.6047"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="var(--bg)" />
        <stop offset="0.905" stop-color="var(--bg)" stop-opacity="0" />
      </linearGradient>
    </defs>
  </svg>

  <img *ngIf="avatarUrl" [src]="avatarUrl" alt="">
</div>
